"use client"

import { useEffect, useState } from "react"
import { useAccount } from "../context/AccountContext"
import { getAuth } from "firebase/auth"
import { getDatabase, ref, get } from "firebase/database"

export const useGetCurrentUserId = () => {
  const { currentAccount, accountSwitchTrigger } = useAccount()
  const [userId, setUserId] = useState(null)
  const [isPartner, setIsPartner] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const determineUserId = async () => {
      setLoading(true)
      const auth = getAuth()
      const user = auth.currentUser

      if (!user) {
        setUserId(null)
        setIsPartner(false)
        setLoading(false)
        return
      }

      const database = getDatabase()

      // 1️⃣ If currentAccount exists in AccountContext, use it directly
      if (currentAccount && currentAccount.uid) {
        setUserId(currentAccount.uid)
        setIsPartner(currentAccount.type === "firm" ? false : false) // main or firm are not partners
        setLoading(false)
        return
      }

      // 2️⃣ If user is listed as a partner under any main account in DB
      try {
        const profilesRef = ref(database, "profileDashboard")
        const profilesSnap = await get(profilesRef)

        if (profilesSnap.exists()) {
          const profiles = profilesSnap.val()
          for (const mainUid in profiles) {
            const mainData = profiles[mainUid]
            
            // Partners node under main account
            if (mainData.partners && mainData.partners[user.uid]) {
              setUserId(mainUid)      // return main user's ID
              setIsPartner(true)
              setLoading(false)
              return
            }

            // Check if user matches any firm UID
            if (mainData.firms && mainData.firms[user.uid]) {
              setUserId(user.uid)      // firm uses its own UID
              setIsPartner(false)
              setLoading(false)
              return
            }
          }
        }
      } catch (error) {
        console.error("[v1] Error checking partner/firms status:", error)
      }

      // 3️⃣ Fallback: Use auth user's own ID
      setUserId(user.uid)
      setIsPartner(false)
      setLoading(false)
    }

    determineUserId()
  }, [currentAccount, accountSwitchTrigger])

  return { userId, isPartner, loading }
}
